import { NucleusError } from '@nucleus/ncu-error';

export class PublishableError extends NucleusError {}
export class PublishableIndexError extends PublishableError {}

export class PublishableIndexTooOld extends PublishableIndexError {
  name = 'PublishableIndexTooOld';
}

export class PublishableIndexTooNew extends PublishableIndexError {
  name = 'PublishableIndexTooNew';
}
